export default function Copy({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 20H6V6H18V20ZM7.59961 18.4004H16.4004V7.59961H7.59961V18.4004ZM20 18H19V5H9V4H20V18Z" fill="currentColor" />
    </svg>
  )
}
